import React from 'react';
import InputMask from 'react-input-mask';
import { Input } from "antd";

const TelefoneInput = ({ nif, setNif, update }) => {
    return (
        <InputMask
            mask="999.999.999-99"
            value={nif}
            disabled={!update}
            onChange={e => setNif(e.target.value)}
        >
            {(inputProps) => (
                <Input
                    {...inputProps}
                    name="nif"
                    className="input-50"
                    placeholder="___.___.___-__"
                />
            )}
        </InputMask>
    );
};

export default TelefoneInput;
